<template>
  <div class="landing-page__collections-carousel">
    <div class="collections-carousel-content" :style="`background: ${props.section?.backgroundColor || '#ffffff'}`">
      <div class="title">
        {{ section.title }}
        <div v-if="section.description" class="description">
          {{ section.description }}
        </div>
      </div>

      <div class="mt-md collections--mobile" v-if="deviceStore.isMobile">
        <div v-for="item, i in transformedCollectionsProps" :key="i">
          <div class="collection--mobile">
            <sib-link v-if="item.url" :to="item.url" :title="item.title">
              <img :src="item.src" :alt="item.title" loading="lazy" />
            </sib-link>
            <img v-else :src="item.src" :alt="item.title" />
            <div class="collection__title">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-md" v-else>
        <sib-carousel v-if="
                transformedCollectionsProps &&
                transformedCollectionsProps.length
                " :items="transformedCollectionsProps" :options="carouselOptions">
          <template #default="{ item }">
            <div class="collection">
              <sib-link v-if="item.url" :to="item.url" :title="item.title">
                <img :src="item.src" :alt="item.title" loading="lazy" />
              </sib-link>
              <img v-else :src="item.src" :alt="item.title" />
              <div class="collection__title">
                {{ item.title }}
              </div>
            </div>
          </template>
        </sib-carousel>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CarouselOptions } from '@/types'
import { computed } from '@vue/reactivity'
import useDeviceStore from '@/store/device'

const props = withDefaults(defineProps<{ section: any }>(), {})

const deviceStore = useDeviceStore()

const transformedCollectionsProps = computed(() => {
  return props.section.collections.map((item:any) => {
    return {
      src: item.image,
      alt: item.title,
      title: item.title,
      url: item.link,
    }
  })
})

const carouselOptions: CarouselOptions = {
  center: true,
  infinite: false,
}
</script>

<style lang="scss">
.landing-page__collections-carousel {
  .collections-carousel-content {
    padding: 1.5rem 1.5rem 0.5rem 1.5rem;
    border-radius: 1rem;
  }
  .title {
    font-size: 23px;
    font-weight: bold;
    text-align: center;
    @include media-md-up {
      font-size: 26px;
    }
  }
  .description{
    font-size: 14px;
    font-weight: 400;
     @include media-md-up {
      font-size: 16px;
    }
  }
  .collections--mobile {
    display: grid;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  .collection--mobile img {
    border-radius: 50%;
    aspect-ratio: 1;
  }
  .carousel {
    --carousel-slide-width: calc((100% - 10em) / 1 - 1px);
    &__slide {
      margin-right: 1em;
      margin-left: 1px;
    }
    &__button.is-prev,
    &__button.is-next {
      border-radius: 1rem;
    }
    &__button.is-prev {
      left: 1.2rem;
    }
    &__button.is-next {
      right: 1.2rem;
    }

    @include media-xl-up {
      --carousel-slide-width: calc((100% - 12em) / 4 - 1px);
    }
  }
  .carousel__dots .carousel__dot {
    width: 20px;
    &::after {
      width: 15px;
      border-radius: 2px;
      height: 5px;
    }
  }
  .carousel__dot.is-selected {
    &::after {
      background: var(--coral-base);
    }
  }
  .collection {
    img {
      border-radius: 10px;
      width: 100%;
      aspect-ratio: 0.7;
      object-fit: cover;
    }
    &__title {
      margin: 4px 0;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      @include media-md-up {
      font-size: 18px;
    }
    }
    a:hover {
      text-decoration: none;
    }
  }
}
</style>
